/**
 * Where signing in or creating an account lands you.
 *
 * The drill, never the profile, and the two entry points must agree.
 *
 * Read from prod on 22 Aug 2026: the only person who is not the author ever to
 * open an account on this app signed up at 15:18:42 UTC on 21 Aug, saved a
 * drill profile seventeen seconds later, and has never attempted a drill.
 * `Login` navigated to `/drill`; `Signup` navigated to `/profile`, which for a
 * brand new account is four zeroes and a settings form. The two had drifted
 * apart and the half that was wrong is the half a stranger uses, because a
 * stranger has no account to sign in with.
 *
 * Kept as one function rather than two string literals so the drift cannot
 * happen again silently.
 */
export const AFTER_AUTH = "/drill";

/**
 * Honour wherever a guard bounced them from, otherwise the drill.
 *
 * Only an absolute in-app path is accepted: `from` arrives in router state and
 * an off-site value would turn either form into an open redirect.
 */
export function afterAuthPath(from?: string | null): string {
  return from && from.startsWith("/") && !from.startsWith("//") ? from : AFTER_AUTH;
}
